// Vendor imports
const _ = require('lodash')
// Client V2 common imports
const { formatBytes } = require('client-v2/common/containers/upload-image-modal/utils')

function isVisibleState(state) {
  return _.get(state, 'headerImageModal.isVisible', false)
}

function fileState(state) {
  const file = _.get(state, 'headerImageModal.droppedFile')
  if (typeof File === 'function' && file instanceof File) {
    return file
  }
}

function savedImageUrlState(state) {
  return _.get(state, 'headerImageModal.savedImageUrl', null)
}

function tipsState(reqs) {
  const supportedFormats = reqs.supportedFormats.join(', ')
  const resizeDimensions = `${reqs.resizeWidth}×${reqs.resizeHeight} pixels`
  const minDimensions = `${reqs.minWidth}×${reqs.minHeight} pixels`
  const maxFileSize = formatBytes(reqs.maxFileSize, 0)
  return [
    `We support these image formats: ${supportedFormats}`,
    `The image will be resized to fit within ${resizeDimensions}.`,
    `Minimum image size is ${minDimensions}.`,
    `Maximum file size is ${maxFileSize}.`
  ]
}

module.exports = {
  fileState,
  isVisibleState,
  savedImageUrlState,
  tipsState
}
